<mat-dialog-content>
  <div class="form-group">
    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
      <mat-label>Titre</mat-label>
      <input
        matInput
        [maxlength]="titreMaxLen"
        [(ngModel)]="item.nom"
      />
      <mat-hint align="end"><code>{{item.nom?.length}}</code> / <code>{{titreMaxLen}}</code></mat-hint>
    </mat-form-field>
  </div>
  <div class="form-group">
    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
      <mat-label>Description</mat-label>
      <input
        matInput
        [maxlength]="descriptionMaxLen"
        [(ngModel)]="item.description"
      />
      <mat-hint align="end"><code>{{item.description?.length}}</code> / <code>{{descriptionMaxLen}}</code></mat-hint>
    </mat-form-field>
  </div>

  <div class="form-group" fxLayout="column">
    <mat-slide-toggle [(ngModel)]="item.condition_obj.is_active" (change)="onChangeCondBlock()" data-cy="bloc-condition-slide-active"> Bloc
      {{ item.condition_obj.is_active === false ? 'normal' : 'avec condition' }}
    </mat-slide-toggle>
    <ng-container *ngIf="item.condition_obj.is_active">
      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <mat-label>Condition</mat-label>
        <input matInput [maxlength]="descriptionMaxLen" [(ngModel)]="item.condition_obj.condition" placeholder="Afficher ce bloc" data-cy="bloc-condition-input-question"/>
        <mat-hint align="end"><code>{{ item.condition_obj.condition?.length }}</code> / <code>{{ descriptionMaxLen }}</code>
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <mat-label>Réponse pour afficher le bloc</mat-label>
        <input matInput [maxlength]="titreMaxLen" [(ngModel)]="item.condition_obj.satisfy" placeholder="Oui" data-cy="bloc-condition-input-yes"/>
        <mat-hint align="end"><code>{{ item.condition_obj.satisfy?.length }}</code> / <code>{{ titreMaxLen }}</code>
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <mat-label>Réponse pour ne pas afficher le bloc</mat-label>
        <input matInput [maxlength]="titreMaxLen" [(ngModel)]="item.condition_obj.other" placeholder="Non" data-cy="bloc-condition-input-no"/>
        <mat-hint align="end"><code>{{ item.condition_obj.other?.length }}</code> / <code>{{ titreMaxLen }}</code></mat-hint>
      </mat-form-field>
    </ng-container>
  </div>

  <div class="form-group administratif">
    <mat-slide-toggle
      [disabled]="administratifBlockExist && isPublicBlock"
      [(ngModel)]="isPublicBlock"
      (change)="onChangeBlock()"> Bloc
      {{isPublicBlock === true ? 'public' : 'administratif'}}
    </mat-slide-toggle>
    <span class="wmess" *ngIf="administratifBlockExist && isPublicBlock">
      L'activation d'un bloc administratif est impossible car il existe déjà un bloc de ce type dans votre formulaire.
      </span>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button color="accent" (click)="onCloseClick()" tabindex="1" data-cy="button-dm-block-modal-confirm">{{confirmButtonText}}</button>
</mat-dialog-actions>
